import { formatNumber } from '../ui';

export function formatReportMoney(value) {
  if (value == null || value === '' || Number.isNaN(Number(value))) return '—';
  return `${formatNumber(Number(value))} Ar`;
}

export function formatReportUnitPrice(value) {
  return formatReportMoney(value);
}

export function formatReportDate(value) {
  if (!value) return '—';
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  } catch {
    return '—';
  }
}
